import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { Select, Check } from "MODULES/shared/components/Forms";
import {
  QUALITY_CONTROL,
  ACCOUNTING,
  CAN_ADD_COMPANIES,
  CAN_UPDATE_COMPANIES
} from "MODULES/users/constants";
import { disabledUnless } from "MODULES/shared/decorators";
import { hasAnyOfRoles, hasPermission } from "MODULES/users/helpers";
import {
  APPROVAL_STATUSES,
  NOT_APPROVED,
  VENDOR_STATUS
} from "../../constants";

const approvalStatusOptions = status => {
  const selectableStatuses = APPROVAL_STATUSES[status].selectableStatuses;
  return selectableStatuses.map(s => ({
    value: s,
    text: APPROVAL_STATUSES[s].label
  }));
};

const VendorStatusSelect = disabledUnless(
  user =>
    hasAnyOfRoles(user.toJS(), [ACCOUNTING, QUALITY_CONTROL]) ||
    hasPermission(user.toJS(), [CAN_ADD_COMPANIES, CAN_UPDATE_COMPANIES])
)(props => (
  <Field
    name={VENDOR_STATUS}
    component={Select}
    label="Vendor Approval"
    options={approvalStatusOptions(props.status)}
    disabled={props.disabled}
  />
));

function RequestVendorApproval() {
  return (
    <div className="form-group">
      <label htmlFor="request_vendor_approval">Vendor Approval</label>
      <div
        className="btn-group btn-group-justified btn-group-vertical"
        data-toggle="buttons"
      >
        <Field
          name="request_vendor_approval"
          component={Check}
          label="Request Approval"
        />
      </div>
    </div>
  );
}

export default function VendorApproval(props) {
  return props.status === NOT_APPROVED ? (
    <RequestVendorApproval />
  ) : (
    <VendorStatusSelect status={props.status} />
  );
}

VendorApproval.propTypes = {
  status: PropTypes.oneOf(Object.keys(APPROVAL_STATUSES))
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/EditApprovals/VendorApproval.jsx